import axios from 'axios';
import { extractFiles } from 'extract-files';

var calculateProgress = function calculateProgress(progressEvent) {
  return parseInt(progressEvent.loaded / progressEvent.total * 100);
};

export var createDriver = function createDriver(_ref) {
  var url = _ref.url;
  var axiosInstance = axios.create({
    baseURL: url
  });
  return function (requestConfig, requestAction, driverActions) {
    var abortSource = axios.CancelToken.source();

    var _extractFiles = extractFiles({
      query: requestConfig.query,
      variables: requestConfig.variables
    }),
        clone = _extractFiles.clone,
        files = _extractFiles.files;

    var data;

    if (files.size === 0) {
      data = clone;
    } else {
      data = new FormData();
      data.append('operations', JSON.stringify(clone));
      var i = 0;
      var map = {};
      files.forEach(function (paths) {
        map[i++] = paths;
      });
      data.append('map', JSON.stringify(map));
      i = 0;
      files.forEach(function (paths, file) {
        data.append(i++, file, file.name);
      });
    }

    var responsePromise = axiosInstance({
      cancelToken: abortSource.token,
      method: 'post',
      data: data,
      headers: requestConfig.headers,
      onDownloadProgress: driverActions.setDownloadProgress && function (progressEvent) {
        if (progressEvent.lengthComputable) {
          driverActions.setDownloadProgress(calculateProgress(progressEvent));
        }
      },
      onUploadProgress: driverActions.setUploadProgress && function (progressEvent) {
        if (progressEvent.lengthComputable) {
          driverActions.setUploadProgress(calculateProgress(progressEvent));
        }
      }
    }).then(function (response) {
      if (response.data.errors) {
        throw response;
      } else {
        return response.data;
      }
    })["catch"](function (error) {
      if (axios.isCancel(error)) {
        throw 'REQUEST_ABORTED';
      }

      throw error;
    });

    responsePromise.cancel = function () {
      return abortSource.cancel();
    };

    return responsePromise;
  };
};